import React, { useState, forwardRef, useCallback, useEffect } from 'react';
import Grid from '@mui/joy/Grid';
import Sheet from '@mui/joy/Sheet';
import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';
import Box from '@mui/joy/Box';


/////////////////// Modal
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import Stack from '@mui/joy/Stack';
import Textarea from '@mui/joy/Textarea';
import { styled } from '@mui/joy';

import AddIconImage from '../../assets/icons/Add-icon.svg'


/////////////// Components
import BloksNews from '../../Components/News/BloksNews';



//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';




/////////////// API
import { createNews, getAllNews } from '../../Api/News';

const schema = yup.object({
    image: yup.mixed().required("يرجى رفع صورة القسم"),
    title_ar: yup.string().required("هذا الحقل مطلوب"),
    title_en: yup.string().required("هذا الحقل مطلوب"),
    content_ar: yup.string().required("هذا الحقل مطلوب"),
    content_en: yup.string().required("هذا الحقل مطلوب"),

})


const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});



const VisuallyHiddenInput = styled('input')`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;


export default function NewsPage() {
    const [openModal, setOpenModal] = useState(false)
    const [open, setOpen] = useState(false);

    const [listNews, setListNews] = useState([]);

    const [urlImageName, setUrlImageName] = useState("قم برفع صورة للخبر")
    const [imageDataTwo, setImageDataTwo] = useState(null)
    const [brandId, setBrandId] = useState(null)

    const [openModalConfirm, setOpenModalConfirm] = useState(false)

    const [loading, setLoading] = useState(false)
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const form = useForm({
        defaultValues: {
            image: '',
            title_ar: "",
            title_en: "",
            content_ar: "",
            content_en: ""
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };

    const imgNews = (event) => {
        let image = event.target;
        if (image.files && image.files[0]) {
            setImageDataTwo(image.files[0]);
            console.log(image.files[0])
            setUrlImageName(image.files[0].name)
            var reader = new FileReader();
            // reader.onload = (e) => {
            //     setUrlImage(e.target.result);
            // }
            reader.readAsDataURL(image.files[0]);
        }
    };

    const getListNews = useCallback( async () => {
        const res = await getAllNews();
        if(res) {
            setListNews(res)
        }
    }, [])

    const sendNewsImage = async (data) => {
        setLoading(true)
        if (data.image) {
            data.image = data.image[0]
        }

        try {
            const res = await createNews(data)
            if (res) {
                setLoading(false)
                setOpen(false)
                getListNews()
                setOpenAlert(true)
                setMessageAlert('تم اضافة قسم بنجاح')
                setValue('image', '')
                setValue('title_ar', '')
                setValue('title_en', '')
                setValue('content_ar', '')
                setValue('content_en', '')
                setImageDataTwo(null)
                setUrlImageName("قم برفع صورة للخبر")
            }

        } catch (error) {
            if (error.response) {
                setLoading(false)
                setOpen(false)
                setOpenAlertError(true)
                setMessageAlertError(error.response.data.message)
            }
        }
    };

    useEffect(() => {
        getListNews();
    }, [getListNews]);


    return (
        <>
            {/* Modal Create New */}
            <Modal
                aria-labelledby="modal-title"
                aria-describedby="modal-desc"
                open={open}
                onClose={() => setOpen(false)}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', overflowY: 'scroll', paddingTop: '150px' }}
            >
                <Sheet
                    variant="outlined"
                    sx={{
                        Width: 500,
                        borderRadius: 'md',
                        p: 3,
                        boxShadow: 'lg',
                        position: 'relative',
                    }}
                >
                    <DialogTitle sx={{ fontSize: '20px', color: '#434448', fontWeight: 'bold' }}>إضافة خبر</DialogTitle>
                    {/* <ModalClose variant="plain" sx={{ m: 1, position: 'absolute', left: '0' }} /> */}
                    <Box sx={{ width: '500px', paddingTop: '30px', direction:'rtl' }}>
                        <form
                            onSubmit={handleSubmit(sendNewsImage)}
                        >
                            <Stack spacing={2}>
                                <FormControl>
                                    <FormLabel>عنوان الخبر</FormLabel>
                                    <Input
                                        sx={{
                                            height: '60px',
                                            borderRadius: '30px'
                                        }}
                                        autoFocus
                                        placeholder='ادخل عنون الخبر هنا.....'
                                        {...register('title_ar')}
                                    />
                                    {errors.title_ar &&
                                        <Typography
                                            color="danger"
                                            level="body-xs"
                                            variant="plain"
                                        >{errors.title_ar?.message}</Typography>
                                    }
                                </FormControl>
                                <FormControl sx={{ direction: 'ltr' }}>
                                    <FormLabel>News title</FormLabel>
                                    <Input
                                        sx={{
                                            height: '60px',
                                            borderRadius: '30px'
                                        }}
                                        autoFocus
                                        placeholder='News title .....'
                                        {...register('title_en')}
                                    />
                                    {errors.title_en &&
                                        <Typography
                                            color="danger"
                                            level="body-xs"
                                            variant="plain"
                                        >{errors.title_en?.message}</Typography>
                                    }
                                </FormControl>

                                <FormControl>
                                    <FormLabel>صورة الخبر</FormLabel>
                                    <Button
                                        component="label"
                                        role={undefined}
                                        tabIndex={-1}
                                        variant="outlined"
                                        color="neutral"
                                        sx={{ border: '1px solid #E6E6E6', padding: '0', position: 'relative', height: '60px', paddingLeft: '40%', borderRadius: '30px' }}
                                        endDecorator={
                                            <Box sx={{ backgroundColor: '#3E64F4', color: '#FFF', position: 'absolute', left: '0', top: '0', width: '30%', height: '60px', textAlign: 'center', lineHeight: '60px', borderRadius: '30px' }}>
                                                Upload
                                            </Box>
                                        }
                                    >
                                        {urlImageName}
                                        <VisuallyHiddenInput type="file" {...register('image')} onChange={(e) => imgNews(e)}/>
                                    </Button>
                                    {errors.image &&
                                        <Typography
                                            color="danger"
                                            level="body-xs"
                                            variant="plain"
                                        >{errors.image?.message}</Typography>
                                    }
                                    <Typography level="h4" sx={{textAlign:'center', margin:'20px 0'}}>يجب رفع صورة بمقاس  350 * 200</Typography>
                                
                                </FormControl>


                                <FormControl>
                                    <FormLabel>تفاصيل الخبر</FormLabel>
                                    <Textarea
                                        placeholder="ادخل تفاصيل الخبر هنا....."
                                        minRows={3}
                                        {...register('content_ar')}
                                        sx={{
                                            '--Textarea-focusedInset': 'var(--any, )',
                                            '--Textarea-focusedThickness': '0.25rem',
                                            '--Textarea-focusedHighlight': 'rgba(13,110,253,.25)',
                                            '&::before': {
                                                transition: 'box-shadow .15s ease-in-out',
                                            },
                                            '&:focus-within': {
                                                borderColor: '#86b7fe',
                                            },
                                            borderRadius: '30px'
                                        }}
                                    />
                                    {errors.content_ar &&
                                        <Typography
                                            color="danger"
                                            level="body-xs"
                                            variant="plain"
                                        >{errors.content_ar?.message}</Typography>
                                    }
                                </FormControl>
                                <FormControl sx={{ direction: 'ltr' }}>
                                    <FormLabel>News details</FormLabel>
                                    <Textarea
                                        placeholder="News details"
                                        minRows={3}
                                        {...register('content_en')}
                                        sx={{
                                            '--Textarea-focusedInset': 'var(--any, )',
                                            '--Textarea-focusedThickness': '0.25rem',
                                            '--Textarea-focusedHighlight': 'rgba(13,110,253,.25)',
                                            '&::before': {
                                                transition: 'box-shadow .15s ease-in-out',
                                            },
                                            '&:focus-within': {
                                                borderColor: '#86b7fe',
                                            },
                                            borderRadius: '30px'
                                        }}
                                    />
                                    {errors.content_en &&
                                        <Typography
                                            color="danger"
                                            level="body-xs"
                                            variant="plain"
                                        >{errors.content_en?.message}</Typography>
                                    }
                                </FormControl>
                                <Box sx={{ display: 'flex', width: '100%', justifyContent: 'flex-end', paddingTop: '40px' }}>
                                    <Button type="submit" loading={loading} sx={{ borderRadius: '15px', backgroundColor: '#3E64F4', height: '60px', width: '170px', marginLeft: '20px' }}>اضافة خبر</Button>
                                    <Button type="button" onClick={() => setOpen(false)} sx={{ borderRadius: '15px', backgroundColor: '#757778', height: '60px', width: '170px' }}>الغاء</Button>
                                </Box>
                            </Stack>
                        </form>
                    </Box>
                </Sheet>
            </Modal>

            <Box sx={{ backgroundColor: '#F7F9FB', padding: '50px 3%' }}>
                <Grid
                    container
                    rowSpacing={1}
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                    sx={{ width: '100%' }}
                >
                    <Grid xs={6}>
                        <Typography level="h2" fontSize="xl" sx={{ mb: 0.5 }}>
                            الأخبار و الأحداث
                        </Typography>
                    </Grid>
                    <Grid xs={6} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={() => setOpen(true)} startDecorator={<img src={AddIconImage} className='imgIconButton' alt='icon add' />}>إضافة خبر جديد</Button>
                    </Grid>
                </Grid>

                <BloksNews listNews={listNews} getListNews={getListNews}/>
            </Box>
        </>
    )
}
